// 分类相关
import * as type from '../constact'
import * as API from '../../api'
import { message } from 'antd'

const defaultState = {
	cateList: [], // 分类列表 全量
}

// action
export const getCateList = (data) => {
	// 返回函数，异步dispatch
	return async dispatch => {
		try {
			const { code, msg, data } = await API.getCategoriesAll()
			if (code !== 0) {
				message.error(msg)
				return
			}
			dispatch({
				type: type.SET_CATE_LIST,
				data
			})
		} catch (err) {
			message.error('获取分类失败')
			console.error('获取分类失败：', err)
		}
	}
}

// reducer
const categoryInfo = (state = defaultState, action) => {
	switch (action.type) {
	case type.SET_CATE_LIST:
		return Object.assign({}, state, {
			cateList: action.data
		})
	default:
		return state
	}
}
export default categoryInfo
